
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/day-of-week",
      function () {
        return require("private-next-pages/day-of-week/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/day-of-week"])
      });
    }
  